import Roles from 'src/security/roles';
import Plans from 'src/security/plans';
import Storage from 'src/security/storage';

const storage = Storage.values;
const roles = Roles.values;
const plans = Plans.values;

class Permissions {
  static get values() {
    return {
      tenantEdit: {
        id: 'tenantEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tenantDestroy: {
        id: 'tenantDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      planEdit: {
        id: 'planEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      planRead: {
        id: 'planRead',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userEdit: {
        id: 'userEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userDestroy: {
        id: 'userDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userCreate: {
        id: 'userCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userImport: {
        id: 'userImport',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userRead: {
        id: 'userRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userAutocomplete: {
        id: 'userAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      auditLogRead: {
        id: 'auditLogRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      settingsEdit: {
        id: 'settingsEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.settingsBackgroundImages,
          storage.settingsLogos,
        ],
      },
      affirmationImport: {
        id: 'affirmationImport',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      affirmationCreate: {
        id: 'affirmationCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.affirmationCommentaryAudio,
        ],
      },
      affirmationEdit: {
        id: 'affirmationEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.affirmationCommentaryAudio,
        ],
      },
      affirmationDestroy: {
        id: 'affirmationDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.affirmationCommentaryAudio,
        ],
      },
      affirmationRead: {
        id: 'affirmationRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      affirmationAutocomplete: {
        id: 'affirmationAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      affirmationProgramImport: {
        id: 'affirmationProgramImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      affirmationProgramCreate: {
        id: 'affirmationProgramCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.affirmationProgramSquareArt,
          storage.affirmationProgramSquareArtHD,
          storage.affirmationProgramLandscapeArt,
          storage.affirmationProgramLandscapeArtHD,
          storage.affirmationProgramPortraitArt,
          storage.affirmationProgramPortraitArtHD,
          storage.affirmationProgramSoundsAudioURL,
        ],
      },
      affirmationProgramEdit: {
        id: 'affirmationProgramEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.affirmationProgramSquareArt,
          storage.affirmationProgramSquareArtHD,
          storage.affirmationProgramLandscapeArt,
          storage.affirmationProgramLandscapeArtHD,
          storage.affirmationProgramPortraitArt,
          storage.affirmationProgramPortraitArtHD,
          storage.affirmationProgramSoundsAudioURL,
        ],
      },
      affirmationProgramDestroy: {
        id: 'affirmationProgramDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.affirmationProgramSquareArt,
          storage.affirmationProgramSquareArtHD,
          storage.affirmationProgramLandscapeArt,
          storage.affirmationProgramLandscapeArtHD,
          storage.affirmationProgramPortraitArt,
          storage.affirmationProgramPortraitArtHD,
          storage.affirmationProgramSoundsAudioURL,
        ],
      },
      affirmationProgramRead: {
        id: 'affirmationProgramRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      affirmationProgramAutocomplete: {
        id: 'affirmationProgramAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      soundImport: {
        id: 'soundImport',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      soundCreate: {
        id: 'soundCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.soundAudioURL,
          storage.soundAlexaAudioURL,
          storage.soundSquareArt,
          storage.soundSquareArtHD,
          storage.soundLandscapeArt,
          storage.soundLandscapeArtHD,
          storage.soundPortraitArt,
          storage.soundPortraitArtHD,
        ],
      },
      soundEdit: {
        id: 'soundEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.soundAudioURL,
          storage.soundAlexaAudioURL,
          storage.soundSquareArt,
          storage.soundSquareArtHD,
          storage.soundLandscapeArt,
          storage.soundLandscapeArtHD,
          storage.soundPortraitArt,
          storage.soundPortraitArtHD,
        ],
      },
      soundDestroy: {
        id: 'soundDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.soundAudioURL,
          storage.soundAlexaAudioURL,
          storage.soundSquareArt,
          storage.soundSquareArtHD,
          storage.soundLandscapeArt,
          storage.soundLandscapeArtHD,
          storage.soundPortraitArt,
          storage.soundPortraitArtHD,
        ],
      },
      soundRead: {
        id: 'soundRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      soundAutocomplete: {
        id: 'soundAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      soundTitleImport: {
        id: 'soundTitleImport',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      soundTitleCreate: {
        id: 'soundTitleCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.soundTitleSquareArt,
          storage.soundTitleSquareArtHD,
          storage.soundTitleLandscapeArt,
          storage.soundTitleLandscapeArtHD,
          storage.soundTitlePortraitArt,
          storage.soundTitlePortraitArtHD,
        ],
      },
      soundTitleEdit: {
        id: 'soundTitleEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.soundTitleSquareArt,
          storage.soundTitleSquareArtHD,
          storage.soundTitleLandscapeArt,
          storage.soundTitleLandscapeArtHD,
          storage.soundTitlePortraitArt,
          storage.soundTitlePortraitArtHD,
        ],
      },
      soundTitleDestroy: {
        id: 'soundTitleDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.soundTitleSquareArt,
          storage.soundTitleSquareArtHD,
          storage.soundTitleLandscapeArt,
          storage.soundTitleLandscapeArtHD,
          storage.soundTitlePortraitArt,
          storage.soundTitlePortraitArtHD,
        ],
      },
      soundTitleRead: {
        id: 'soundTitleRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      soundTitleAutocomplete: {
        id: 'soundTitleAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      subscriptionTierImport: {
        id: 'subscriptionTierImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      subscriptionTierCreate: {
        id: 'subscriptionTierCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.subscriptionTierSquareArt,
          storage.subscriptionTierSquareArtHD,
          storage.subscriptionTierLandscapeArt,
          storage.subscriptionTierLandscapeArtHD,
          storage.subscriptionTierPortraitArt,
          storage.subscriptionTierPortraitArtHD,
        ],
      },
      subscriptionTierEdit: {
        id: 'subscriptionTierEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.subscriptionTierSquareArt,
          storage.subscriptionTierSquareArtHD,
          storage.subscriptionTierLandscapeArt,
          storage.subscriptionTierLandscapeArtHD,
          storage.subscriptionTierPortraitArt,
          storage.subscriptionTierPortraitArtHD,
        ],
      },
      subscriptionTierDestroy: {
        id: 'subscriptionTierDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.subscriptionTierSquareArt,
          storage.subscriptionTierSquareArtHD,
          storage.subscriptionTierLandscapeArt,
          storage.subscriptionTierLandscapeArtHD,
          storage.subscriptionTierPortraitArt,
          storage.subscriptionTierPortraitArtHD,
        ],
      },
      subscriptionTierRead: {
        id: 'subscriptionTierRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      subscriptionTierAutocomplete: {
        id: 'subscriptionTierAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      entitlementImport: {
        id: 'entitlementImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      entitlementCreate: {
        id: 'entitlementCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      entitlementEdit: {
        id: 'entitlementEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      entitlementDestroy: {
        id: 'entitlementDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      entitlementRead: {
        id: 'entitlementRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      entitlementAutocomplete: {
        id: 'entitlementAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      affirmationProgramEntitlementImport: {
        id: 'affirmationProgramEntitlementImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      affirmationProgramEntitlementCreate: {
        id: 'affirmationProgramEntitlementCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      affirmationProgramEntitlementEdit: {
        id: 'affirmationProgramEntitlementEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      affirmationProgramEntitlementDestroy: {
        id: 'affirmationProgramEntitlementDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      affirmationProgramEntitlementRead: {
        id: 'affirmationProgramEntitlementRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      affirmationProgramEntitlementAutocomplete: {
        id: 'affirmationProgramEntitlementAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      userEntitlementImport: {
        id: 'userEntitlementImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userEntitlementCreate: {
        id: 'userEntitlementCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      userEntitlementEdit: {
        id: 'userEntitlementEdit',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      userEntitlementDestroy: {
        id: 'userEntitlementDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      userEntitlementRead: {
        id: 'userEntitlementRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userEntitlementAutocomplete: {
        id: 'userEntitlementAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      usageLogImport: {
        id: 'usageLogImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      usageLogCreate: {
        id: 'usageLogCreate',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      usageLogEdit: {
        id: 'usageLogEdit',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      usageLogDestroy: {
        id: 'usageLogDestroy',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      usageLogRead: {
        id: 'usageLogRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      usageLogAutocomplete: {
        id: 'usageLogAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      userAffirmationProgramImport: {
        id: 'userAffirmationProgramImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userAffirmationProgramCreate: {
        id: 'userAffirmationProgramCreate',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      userAffirmationProgramEdit: {
        id: 'userAffirmationProgramEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      userAffirmationProgramDestroy: {
        id: 'userAffirmationProgramDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      userAffirmationProgramRead: {
        id: 'userAffirmationProgramRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      userAffirmationProgramAutocomplete: {
        id: 'userAffirmationProgramAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      enterpriseAlexaSkillImport: {
        id: 'enterpriseAlexaSkillImport',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      enterpriseAlexaSkillCreate: {
        id: 'enterpriseAlexaSkillCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      enterpriseAlexaSkillEdit: {
        id: 'enterpriseAlexaSkillEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      enterpriseAlexaSkillDestroy: {
        id: 'enterpriseAlexaSkillDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      enterpriseAlexaSkillRead: {
        id: 'enterpriseAlexaSkillRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      enterpriseAlexaSkillAutocomplete: {
        id: 'enterpriseAlexaSkillAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      alexaI18nImport: {
        id: 'alexaI18nImport',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      alexaI18nCreate: {
        id: 'alexaI18nCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      alexaI18nEdit: {
        id: 'alexaI18nEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      alexaI18nDestroy: {
        id: 'alexaI18nDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      alexaI18nRead: {
        id: 'alexaI18nRead',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      alexaI18nAutocomplete: {
        id: 'alexaI18nAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      passwordChangeMember: {
        id: 'passwordChangeMember',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      reporting: {
        id: 'reporting',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      wellnessCheckImport: {
        id: 'wellnessCheckImport',
        allowedRoles: [],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },

      wellnessCheckCreate: {
        id: 'wellnessCheckCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.wellnessCheckResultPdf,
          storage.wellnessCheckIntentionSound,
        ],
      },

      wellnessCheckEdit: {
        id: 'wellnessCheckEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.wellnessCheckResultPdf,
          storage.wellnessCheckIntentionSound,
        ],
      },
      wellnessCheckDestroy: {
        id: 'wellnessCheckDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [
          storage.wellnessCheckResultPdf,
          storage.wellnessCheckIntentionSound,
        ],
      },
      wellnessCheckRead: {
        id: 'wellnessCheckRead',
        allowedRoles: [
          roles.admin,
          roles.readonly,
          roles.member,
        ],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      wellnessCheckAutocomplete: {
        id: 'wellnessCheckAutocomplete',
        allowedRoles: [roles.admin, roles.readonly],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      giftCardsCreate: {
        id: 'giftCardsCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      giftCardsEdit: {
        id: 'giftCardsEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizCreate: {
        id: 'quizCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizEdit: {
        id: 'quizEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizDestroy: {
        id: 'quizDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizRead: {
        id: 'quizRead',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizQuestionCreate: {
        id: 'quizQuestionCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizQuestionEdit: {
        id: 'quizQuestionEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizQuestionDestroy: {
        id: 'quizQuestionDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      quizQuestionRead: {
        id: 'quizQuestionRead',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      meditationCreate: {
        id: 'meditationCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      meditationEdit: {
        id: 'meditationEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      meditationDestroy: {
        id: 'meditationDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      meditationRead: {
        id: 'meditationRead',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      achievementCreate: {
        id: 'achievementCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      achievementEdit: {
        id: 'achievementEdit',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      achievementDestroy: {
        id: 'achievementDestroy',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      achievementRead: {
        id: 'achievementRead',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
      },
      tagRead: {
        id: 'tagRead',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
      tagCreate: {
        id: 'tagCreate',
        allowedRoles: [roles.admin],
        allowedPlans: [
          plans.free,
          plans.growth,
          plans.enterprise,
        ],
        allowedStorage: [],
      },
    };
  }

  static get asArray() {
    return Object.keys(this.values).map((value) => {
      return this.values[value];
    });
  }
}

export default Permissions;
